import React, { Component } from 'react';

const Title = ({ children }) => (
  <h1 className="title">{children}</h1>
)

export default Title;
